class UrlTemplate {
	constructor(url) {
		this.url = url;
	}

	isNotNull(value) {
		return value != 'NULL';
	}

	// r for replace
	r(placeholder, value) {
		if (this.isNotNull(value)) {
			this.url = this.url.replace(placeholder, encodeURIComponent(value));
		} else {
			this.url = this.url.replace(placeholder, encodeURIComponent(' '));
		}
		return this;
	}
}
